import axios from "../axiosInstance";

class EmpresaService {
  async listarEmpresasExame(idExame) {
    return await axios.post("/empresa/empresas", {
      IdExame: idExame
    });
  }

  async obterDadosEmpresa(apelidoEmpresa, idEmpresa) {
    return await axios.get(`/empresa/informacoes/`, {
      params: {
        idEmpresa,
        apelidoEmpresa
      }
    });
  }

  async listarEmpresasHelp() {
    return await axios.get(`/empresa/help/`);
  }
}
export default new EmpresaService();
